export const environment = {
  production: true,
  parse: {
    appId: 'kxjdlPTjy5YgansoTZVHV2pO0mA5aqZ0ou0p9LCi',
    javascriptKey: 'C4a1vtWqqYHxVFb9KOd5ogOG9aQpnaDxLtmsvR2M',
  },
};
